export default __webpack_public_path__ + "static/media/leverkusen_light.42ad3a71.png";